/**
 * KPI stat card (epic-6) — a single headline metric with an icon + caption.
 * Data-dense dashboard style: compact, gridable, high data-ink ratio.
 */
import type { IconName } from '../../components/Icon';
import { Icon } from '../../components/Icon';

interface Props {
  label: string;
  value: string;
  caption?: string;
  icon: IconName;
}

export function KpiCard({ label, value, caption, icon }: Props) {
  return (
    <div className="rounded-2xl border border-line bg-white p-5 shadow-card">
      <div className="flex items-center gap-2 text-ink-500">
        <Icon name={icon} className="h-5 w-5 text-primary" />
        <span className="text-sm font-medium">{label}</span>
      </div>
      <p className="mt-3 text-3xl font-bold tabular-nums text-ink">{value}</p>
      {caption ? <p className="mt-1 text-xs text-ink-500">{caption}</p> : null}
    </div>
  );
}

export default KpiCard;
